module.exports = __webpack_public_path__ + "img/institucional.abb2b983.jpg";